import { Module } from "vuex";
import RootState from "./root-state";
import TaskType from "@/entities/task-type";
import TaskTypeApi from "@/api/gateways/task-type-api";
import { TaskTypeId } from "@/entities/ids";

export default {
  namespaced: true,
  state: {
    tasktypes: []
  },
  getters: {
    all(state) {
      return state.tasktypes;
    }
  },
  mutations: {
    init(state, tasktypes: TaskType[]) {
      state.tasktypes = tasktypes;
    }
  },
  actions: {
    async init({ commit, rootGetters }) {
      const gw = new TaskTypeApi(rootGetters.api);
      commit("init", await gw.all());
    },
    async save({ dispatch, rootGetters }, tasktype: TaskType) {
      const gw = new TaskTypeApi(rootGetters.api);
      await gw.save(tasktype);
      await dispatch("init");
    },
    async sort({ commit, dispatch, rootGetters }, tasktypes: TaskType[]) {
      // 一旦代入しないとDnDでラグが生じる
      commit("init", tasktypes);
      const gw = new TaskTypeApi(rootGetters.api);
      const ids = tasktypes.map(t => t.id);
      await gw.sort(ids);
      await dispatch("init");
    },
    async remove({ dispatch, rootGetters }, id: TaskTypeId) {
      const gw = new TaskTypeApi(rootGetters.api);
      await gw.remove(id);
      await dispatch("init");
    }
  }
} as Module<TaskTypeState, RootState>;

interface TaskTypeState {
  tasktypes: TaskType[];
}
